import {LogOut} from 'lucide-react';
import {getIdToken, getTokenPayload, clearTokens} from '@/utils/authStorage';
import {getCognitoLogoutUrl} from '@/config/authConfig';
import {DEV_AUTH_BYPASS, DEV_USER} from '@/lib/auth/devBypass';
import {Button} from '@/components/ui/Button';

interface TokenPayload {
  email?: string;
  name?: string;
  cognito_username?: string;
}

function loadUser(): TokenPayload | null {
  if (DEV_AUTH_BYPASS) return DEV_USER;
  const token = getIdToken();
  return token ? getTokenPayload(token) : null;
}

export function UserMenu() {
  const user = loadUser();
  if (!user) return null;

  const handleLogout = async () => {
    clearTokens();
    if (DEV_AUTH_BYPASS) {
      window.location.reload();
      return;
    }
    window.location.href = await getCognitoLogoutUrl();
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      className="gap-2 px-3"
      onClick={handleLogout}
    >
      <LogOut className="h-4 w-4" />
      <span className="text-sm font-medium">Log out</span>
    </Button>
  );
}
